// in src/Dashboard.js
import React, { useState, useEffect } from 'react';




import Grid from '@mui/material/Grid';
import Box from '@material-ui/core/Box';



import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';


import { useRefresh, useDataProvider, useNotify, useSetLocale } from 'react-admin';import { parse } from 'query-string';


import { useTranslate, setAssociationLang } from '../common/language';import { makeStyles } from '@material-ui/core/styles';


import IconButton from '@mui/material/IconButton';






const useStyles = makeStyles((theme) => ({  
  largeIconOK: {
    '& svg': {
      fontSize: 200,
      color: '#007E12'
    }
  }
  ,
  largeIconKO: {
    '& svg': {
      fontSize: 200,
      color: '#FF7373'
    }
  }
}));


export const CheckMembers = props => {
    
  const translate = useTranslate();  
  const dataProvider = useDataProvider();
  const classes = useStyles();
    
  const [info, setInfo] = useState();
  const [checkMemberData, setCheckMemberData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorApi, setErrorApi] = useState();
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
  const setLocale  = useSetLocale();
    
  const { id: id_string, hash: hash_string } = parse(props.location.search);
    
  useEffect(() => {
    dataProvider.getOne('users_groups/public/check_members/' + id_string, { id: hash_string })
      .then(( { data } ) => { 
        setCheckMemberData(data);    
        setLoading(false);  
      })
      .catch(error => {      
        setError(true);
        setLoading(false);                  
      });
  }, []);
  
  useEffect(() => {
      if (checkMemberData)
      {
          setAssociationLang(checkMemberData.lang); 
      }
    }, [checkMemberData]);
        
  if (loading) return null;
  
  const topLogoUrl = checkMemberData ? checkMemberData.top_logo : null;
  const bottomLogoUrl = checkMemberData ? checkMemberData.bottom_logo : null;
  const backgroundColor = checkMemberData && checkMemberData.background_color ? checkMemberData.background_color : '#efefef';
  const formatDate = value => {
    if (!value) return null;
    
    const isoDate = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDate) return isoDate[3] + '-' + isoDate[2] + '-' + isoDate[1];
    
    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) return value;
    
    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    return day + '-' + month + '-' + parsedDate.getFullYear();
  };
  const showMinorValue = value => value === null || value === undefined ? null : value ? translate('common.yes') : translate('common.no');
  const CheckField = ({ show, label, value }) => (
    show && value !== undefined && value !== null && value !== '' ?
      <Grid item xs={12} align="center">  
        <b>{label}</b><br />{value}
      </Grid>
    : null
  );
    
  if (error || checkMemberData.status !== 1) return (
    <Box sx={{ width: '90%', maxWidth: 800, bgcolor: backgroundColor, padding: '0px' }} className="add_member_box" >
      <Grid container spacing={2}>
        <Grid item xs={12} align="center">                      
          <IconButton className={classes.largeIconKO}>
            <CancelOutlinedIcon />
          </IconButton>
        </Grid>
        <Grid item xs={12} align="center">  
          {translate('check_members.not_found')}
          <br />
          <br />
        </Grid>
      </Grid>                 
    </Box>);
            
    
    
  return (
    <Box sx={{ width: '90%', maxWidth: 800, bgcolor: backgroundColor, padding: '0px' }} className="add_member_box" >
      <Grid container spacing={2}>
        {topLogoUrl ?
          <Grid item xs={12} align="center" className="card_validation_logo_container">
            <img src={topLogoUrl} className="card_validation_logo" alt={translate('settings.card_validation_top_logo')} />
          </Grid>
        : null}
        <Grid item xs={12} align="center">  
          {checkMemberData.status === 1 ?                             
            <IconButton className={classes.largeIconOK}>
              <CheckCircleOutlineIcon />
            </IconButton>
            :
            <IconButton className={classes.largeIconKO}>
              <CancelOutlinedIcon />
            </IconButton>
          }
        </Grid>                    
        <CheckField show={checkMemberData.show_association_name} label={translate('check_members.checker_association_name')} value={checkMemberData.association_name} />
        <CheckField show={checkMemberData.show_group_name} label={translate('check_members.checker_group_name')} value={checkMemberData.group_name} />
        <CheckField show={checkMemberData.show_name} label={translate('check_members.checker_name')} value={checkMemberData.name} />
        <CheckField show={checkMemberData.show_nif} label={translate('check_members.checker_nif')} value={checkMemberData.nif} />
        <CheckField show={checkMemberData.show_birthday} label={translate('check_members.checker_birthday')} value={formatDate(checkMemberData.birthday)} />
        <CheckField show={checkMemberData.show_num_member} label={translate('check_members.checker_num_member')} value={checkMemberData.num_member} />
        <CheckField show={checkMemberData.show_minor} label={translate('check_members.checker_minor')} value={showMinorValue(checkMemberData.minor_age)} />
        <CheckField show={checkMemberData.show_date_join} label={translate('check_members.checker_date_join')} value={formatDate(checkMemberData.date_join)} />
        <CheckField show={checkMemberData.show_date_left} label={translate('check_members.checker_date_left')} value={formatDate(checkMemberData.date_left)} />
        <Grid item xs={12} align="center">  
          <b>{translate('check_members.checker_date')}</b><br />{checkMemberData.date_checker}
          <br />
          <br />
        </Grid>
        {bottomLogoUrl ?
          <Grid item xs={12} align="center" className="card_validation_logo_container">
            <img src={bottomLogoUrl} className="card_validation_logo" alt={translate('settings.card_validation_bottom_logo')} />
          </Grid>
        : null}
      </Grid>                 
    </Box>
  );
};

/*

<br/><br/><br/><MyLoading />

<Grid item xs={12} align="center">  
    {translate('check_members.status_' + checkMemberData.status)}
</Grid>
<Grid item xs={12} align="center">  
    {checkMemberData.association_name}
</Grid>
<Grid item xs={12} align="center">  
    {checkMemberData.group_name}
</Grid>
<Grid item xs={12} align="center">  
    {checkMemberData.name}
</Grid>
<Grid item xs={12} align="center">  
    {checkMemberData.date_join}
</Grid>
<Grid item xs={12} align="center">  
    {checkMemberData.date_left}
</Grid>
*/
